var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/to-integer.js
// module id = 87
// module chunks = 1